import { authenticated } from './WebRequest';
import type {
  ApiThunk,
  OrderUploadStatusResponse,
  SiteId,
} from './types/UploadOrdersStatus';

export type {
  ApiThunk,
  OrderUploadStats,
  OrderUploadStatusResponse,
  OrderUploadStatusValue,
  SiteId,
} from './types/UploadOrdersStatus';

export function getOrderUploadStatus(
  siteId: SiteId
): ApiThunk<OrderUploadStatusResponse> {
  return authenticated.get(`/upload_handler/${siteId}/upload_orders_status`);
}
